import type { Technique } from '../types';
import { FRAGMENTATION_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type FragmentationState } from './render';

export const fragmentation: Technique<FragmentationState> = {
  id: 'fragmentation',
  name: 'Glyphen-Fragmentierung',
  category: 'deconstruction',
  description: 'Bricht die Buchstaben in Scherben und schiebt sie auseinander — ohne Physik, dafür reproduzierbar.',
  params: FRAGMENTATION_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
